import { borderRadius, typography, spacing, transitions, zIndex, colors } from './tokens';
export const darkTheme = {
    mode: 'dark',
    colors: {
        bg: {
            primary: colors.neutral[950], // #020205 — true void
            secondary: colors.neutral[900], // #080812
            tertiary: colors.neutral[800], // #0d0d1a
            inverse: colors.neutral[0],
        },
        text: {
            primary: colors.neutral[50], // #f0eeff — violet-tinted white
            secondary: colors.neutral[200], // #a8a4bf
            tertiary: colors.neutral[400], // #56566a
            inverse: colors.neutral[900],
            link: colors.primary[400],
        },
        border: {
            subtle: 'rgba(255,255,255,0.06)',
            default: 'rgba(255,255,255,0.10)',
            strong: 'rgba(255,255,255,0.18)',
        },
        brand: {
            primary: colors.primary[500], // #8b5cf6
            primaryHover: colors.primary[400], // #a78bfa
            primaryActive: colors.primary[300], // #c4b5fd
            primaryText: colors.neutral[0],
            accent: colors.accent[500], // #00d9b4
            accentHover: colors.accent[400], // #2dd4b4
        },
        success: colors.success.light,
        warning: colors.warning.light,
        error: colors.error.light,
        info: colors.info.light,
    },
    shadows: {
        sm: '0 1px 3px 0 rgb(0 0 0 / 0.5)',
        md: '0 4px 16px -1px rgb(0 0 0 / 0.6), 0 0 1px rgba(255,255,255,0.04)',
        lg: '0 12px 32px -3px rgb(0 0 0 / 0.7), 0 0 1px rgba(255,255,255,0.05)',
        xl: '0 24px 48px -5px rgb(0 0 0 / 0.8), 0 0 1px rgba(255,255,255,0.06)',
        '2xl': '0 40px 80px -8px rgb(0 0 0 / 0.9), 0 0 1px rgba(255,255,255,0.06)',
        glow: '0 0 24px rgb(139 92 246 / 0.55), 0 0 60px rgb(139 92 246 / 0.2)',
        glowAccent: '0 0 24px rgb(0 217 180 / 0.55), 0 0 60px rgb(0 217 180 / 0.2)',
        inner: 'inset 0 2px 6px 0 rgb(0 0 0 / 0.4)',
    },
    borderRadius,
    typography,
    spacing,
    transitions,
    zIndex,
};
//# sourceMappingURL=darkTheme.js.map